import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EditUserComponent from '../../../components/Admin/users/EditUserComponent';

const EditUserPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/khach-hang');
    }

    return <EditUserComponent userId={ params.userId }  shouldRedirect={ () => redirect() } />;
}

export default EditUserPage;
